export default __webpack_public_path__ + "static/media/Automated Investing.34ca61ed.png";